import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { Slice, CountryInfo, CountryInfoSlice } from './types'
import { PWAThunk } from 'lib/core/data'

export const initialState: Slice = {}

interface ActionData {
  countryCode: string
  data?: CountryInfo
}

const makeSlice = (slice: CountryInfoSlice): CountryInfoSlice => {
  return slice ?? ({
    isFetching: false,
    isSuccess: false,
    isFailure: false,
    payload: undefined
  })
}

const slice = createSlice({
  name: 'common/countryInfo',
  initialState,
  reducers: {
    request (state, action: PayloadAction<ActionData>) {
      const { countryCode } = action.payload
      const slice = makeSlice(state[countryCode])

      slice.isFetching = true
      state[countryCode] = slice
    },

    success (state, action: PayloadAction<ActionData>) {
      const { countryCode, data } = action.payload
      const slice = makeSlice(state[countryCode])

      slice.isFetching = false
      slice.isSuccess = true
      slice.isFailure = false
      slice.payload = data
      state[countryCode] = slice
    },

    failure (state, action: PayloadAction<ActionData>) {
      const { countryCode } = action.payload
      const slice = makeSlice(state[countryCode])

      slice.isFetching = false
      slice.isSuccess = false
      slice.isFailure = true
      slice.payload = undefined
      state[countryCode] = slice
    }
  }
})

export const reducer = slice.reducer

export const { request, success, failure } = slice.actions

export function fetchCountryInfo (countryCode: string): PWAThunk {
  return async (dispatch, getState, params) => {
    const { magentoClient } = params
    dispatch(request({ countryCode }))
    try {
      const response = await magentoClient.getClient().directory.fetchCountryInfo({ countryCode })
      const { data } = response || {}
      const { country } = data || {}
      if (country) {
        dispatch(success({
          countryCode,
          data: country
        }))
      } else {
        dispatch(failure({ countryCode }))
      }
      return response
    } catch (e) {
      dispatch(failure({ countryCode }))
    }
  }
}
